var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"calendar-item",class:_vm.buildClasses,attrs:{"href":_vm.buildHref,"title":_vm.itemTitle(_vm.item, _vm.timezone)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }